<template>
  <v-form ref="recommendationForm">
    <v-card class="flex-col-center-start gap-3 pa-4">
      <div class="flex-row-start-center gap-3 w-100">
        <v-card
          v-for="item in targetItems"
          :key="item"
          outlined
          class="w-100 px-4 py-4 flex-row-center-center"
          @click="onSelectTarget(item)"
        >
          <Radio :selected="target === item" :title="$t(item)" />
        </v-card>
      </div>
      <div class="flex-row-start-center gap-3 w-100">
        <v-card
          v-for="item in intervalItems"
          :key="item"
          outlined
          class="w-100 px-4 py-4 flex-row-center-center"
          @click="onSelectInterval(item)"
        >
          <Radio :selected="interval === item" :title="`${item} hours`" />
        </v-card>
      </div>
      <v-text-field
        @input="onValueChange"
        :value="value"
        :rules="[
          rules.required,
          rules.range(value, targetRange.min, targetRange.max),
        ]"
        class="target-value"
        background-color="background"
        :suffix="`(${unit})`"
        type="number"
        flat
        solo
      />
      <v-spacer></v-spacer>
      <v-btn
        color="text"
        class="white--text"
        min-width="250"
        :loading="loading"
        @click="onSubmit"
      >
        {{ $t("calculate") }}
      </v-btn>
    </v-card>
  </v-form>
</template>

<script>
import Radio from "@/components/structure/Radio";
import {
  RECOMMENDATION_RANGES,
  RECOMMENDATION_UNIT,
  VALIDATION_RULES,
} from "@/core/constants";

export default {
  name: "RecommendationForm",

  props: {
    target: { type: String, required: true },
    value: { required: true },
    loading: { type: Boolean, default: false },
    interval: { type: Number, required: true },
  },

  data() {
    return {
      targetItems: ["carbon", "metallization", "productionRate"],
      intervalItems: [3, 5, 8],
      rules: VALIDATION_RULES,
    };
  },

  computed: {
    unit() {
      return RECOMMENDATION_UNIT[this.target];
    },
    targetRange() {
      return RECOMMENDATION_RANGES[this.target];
    },
  },

  methods: {
    onSubmit() {
      const isValid = this.$refs.recommendationForm.validate();
      if (isValid) this.$emit("submit");
    },
    onSelectTarget(target) {
      this.$emit("selectTarget", target);
    },
    onSelectInterval(interval) {
      this.$emit("selectInterval", interval);
    },
    onValueChange(value) {
      this.$emit("change", Number(value));
    },
  },

  components: {
    Radio,
  },
};
</script>

<style lang="scss">
.target-value {
  min-width: 400px;
  direction: ltr;
}
</style>
